import { useEffect, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import "./Navbar1.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../Langswitch/Langswitch";

const Navbar1 = () => {
  const { t } = useTranslation();

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [expand, setExpand] = useState(true);
  //   const [isFixed, setIsFixed] = useState(false);
  // fixed Header
  //   function scrollHandler() {
  //     if (window.scrollY >= 100) {
  //       setIsFixed(true);
  //     } else if (window.scrollY <= 50) {
  //       setIsFixed(false);
  //     }
  //   }
  //   window.addEventListener("scroll", scrollHandler);
  // useEffect(()=> {
  //   if(CartItem.length ===0) {
  //     const storedCart = localStorage.getItem("cartItem");
  //     setCartItem(JSON.parse(storedCart));
  //   }
  // },[])

  <ul className="tm-header-icons">
    <li className="login-icon login-icon-two">
      <div className="dropdown dropdown-four dropdown-icon">
        <Link
          to="/Myprofile"
          onClick={handleLinkClick}
          className="my-profile-icon"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z" />
          </svg>
          <div className="account-list-text">
            <p>Hello, sign in</p>
            <h3>Account &amp; Lists ⯆</h3>
          </div>
        </Link>
      </div>
    </li>
    <li>
      <Link to="/wishlist" onClick={handleLinkClick}>
        <i className="ion-android-favorite-outline" />
        <span>0</span>
      </Link>
    </li>
    <li>
      <Link to="/cart" onClick={handleLinkClick}>
        <i className="ion-bag" />
        <span>0</span>
      </Link>
    </li>
  </ul>;
  return (
    <Navbar
      fixed="top"
      expand="md"
      className="nav-bar-a"
      //   className={isFixed ? "navbar fixed" : "navbar"}
    >
      <Container className="navbar-container aaazzz">
        <Navbar.Brand to="/">
          <ion-icon name="bag"></ion-icon>
          <Link
            to="/Home"
            onClick={handleLinkClick}
            className="tm-header-logo"
          >

          <img
            src="assets/images/logo.png"
            alt="Kurtis Fashion"
            className="logo"
          />
          </Link>
        </Navbar.Brand>

        {/* Media cart and toggle */}
        <div className="d-flex">
          <div className="media-cart">
            <ul className="tm-header-icons">
              <li className="login-icon login-icon-two">
                <div className="dropdown dropdown-four dropdown-icon">
                  <Link
                    to="/Myprofile"
                    onClick={handleLinkClick}
                    className="my-profile-icon"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                    >
                      <path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z" />
                    </svg>
                    <div className="account-list-text">
                      <p>Hello, sign in</p>
                      <h3>Account &amp; Lists ⯆</h3>
                    </div>
                  </Link>
                </div>
              </li>
              <li>
                <Link to="/wishlist" onClick={handleLinkClick}>
                  <i className="ion-android-favorite-outline" />
                  <span>0</span>
                </Link>
              </li>
              <li>
                <Link to="/cart" onClick={handleLinkClick}>
                  <i className="ion-bag" />
                  <span>0</span>
                </Link>
              </li>
            </ul>
          </div>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => {
              setExpand(expand ? false : "expanded");
            }}
            style={{ color: "#ae4b84" }}
          >
            <span></span>
            <span></span>
            <span></span>
          </Navbar.Toggle>
        </div>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="justify-content-end flex-grow-1 pe-3">
            <Nav.Item>
              <Link
                aria-label="Go to Home Page"
                className="navbar-link"
                to="/"
                onClick={handleLinkClick}
              >
                <span className="nav-link-label">{t("Home")}</span>
                
              </Link>
            </Nav.Item>

            <Nav.Item>
              <Link
                aria-label="Go to Shop Page"
                className="navbar-link"
                to="/products"
                onClick={handleLinkClick}
              >
                <span className="nav-link-label">{t("Shop")}</span>
              </Link>
            </Nav.Item>

            <Nav.Item className="expanded-cart">
              <ul className="tm-header-icons">
                <li className="login-icon login-icon-two">
                  <div className="dropdown dropdown-four dropdown-icon">
                    <Link
                      to="/Myprofile"
                      onClick={handleLinkClick}
                      className="my-profile-icon"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z" />
                      </svg>
                      <div className="account-list-text">
                        <p>{t("Hello")}</p>
                        <h3>{t("Account")}⯆</h3>
                      </div>
                    </Link>
                  </div>
                </li>
                <li>
                  <Link to="/wishlist" onClick={handleLinkClick}>
                    <i className="ion-android-favorite-outline" />
                    <span>0</span>
                  </Link>
                </li>
                <li>
                  <Link to="/cart" onClick={handleLinkClick}>
                    <i className="ion-bag" />
                    <span>0</span>
                  </Link>
                </li>
              </ul>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
      <div className="language-switcher-container">
        <LanguageSwitcher />
      </div>
    </Navbar>
   
    
    
    

  );
};

export default Navbar1;
